import { render, staticRenderFns } from "./flowTree.vue?vue&type=template&id=1b632b44&scoped=true&"
import script from "./flowTree.vue?vue&type=script&lang=js&"
export * from "./flowTree.vue?vue&type=script&lang=js&"
import style0 from "./flowTree.vue?vue&type=style&index=0&id=1b632b44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b632b44",
  null
  
)

export default component.exports